import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type CategoryType = {
  id: string | null;
  idx: number;
  isCollection?: boolean;
};

interface CategoryState {
  selectedCategory: CategoryType;
  setSelectedCategory: (category: CategoryType) => void;
  hasData: boolean;
  setHasData: (hasData: boolean) => void;
}

export const useCategoryStore = create<CategoryState>()(
  persist(
    (set) => ({
      selectedCategory: { id: null, idx: 0, isCollection: false },
      setSelectedCategory: (category) => set({ selectedCategory: category }),
      hasData: true,
      setHasData: (hasData) => set({ hasData }),
    }),
    {
      name: "category-storage", // unique name for the storage key
      storage: createJSONStorage(() => sessionStorage), // use sessionStorage
    }
  )
);
